import styled from 'styled-components';
import variables from '@styles/variables';
import { rem } from 'polished';

export const StyledProductListItem = styled.div`
  padding: ${rem(16)};
  display: flex;
  flex-direction: row;

  &:first-child {
    border-top: ${rem(1)} solid ${variables.colors.mediumGray};
  }

  border-bottom: ${rem(1)} solid ${variables.colors.mediumGray};
`;

export const StyledProductInfo = styled.div<{ $opacity?: number }>`
  align-content: center;
  flex: 1;
  opacity: ${({ $opacity = 1 }) => $opacity};

  // Allow ellipsis to show
  min-width: 0;
`;
